import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const ArrowForwardIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 13;
  const color = props.color || '#999999';
  return <Icon name={'arrowForward'} size={size} color={color} />;
};

export default React.memo(ArrowForwardIcon);
